import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';// Asegúrate de que esta ruta es correcta
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '@auth0/auth0-angular';
import { Location } from '@angular/common';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private token: string = '';

  constructor(private authService: AuthService, private router: Router,private location: Location) {
    this.authService.idTokenClaims$.subscribe(token => {
      this.token = token?.__raw || '';
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedReq = req;
    if (this.token) {
      clonedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${this.token}`)
      });
    }

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.status === 401) {
      if (this.location.path() !== '/registro-exitoso'){ 
        this.authService.logout(); 
        this.router.navigate(['/login']);}
    } else if (error.status === 400) {
      this.showError('Bad Request', error.error.message);
    } else if (error.status === 404) {
      this.showError('Not Found', error.error.message);
    } else {
      this.showError('Error', 'Ocurrió un error al procesar la solicitud.');
    }

    console.error('HTTP Error:', error);
    return throwError(error);
  }

  private showError(title: string, message: string) {
    Swal.fire({
      title: title,
      text: message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
}